import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {ServicesContainer, ServicesH1} from './ServiceElements'
import  './styles.css'

const Slider = () => {

  const company = [
    {
      name: "Amazon",
      logo: "amazon.png",
    },
    // {
    //   name: "Microsoft",
    //   logo: "microsoft.png",
    // },
    {
      name: "Google",
      logo: "google.png",
    },
    {
      name: "Goldman Sachs",
      logo: "goldman_sachs.png",
    },
    {
      name: "IBM",
      logo: "ibm.png",
    },
    {
      name: "Flipkart",
      logo: "flipkart.png",
    },
    {
      name: "JPMorgan Chase & Co.",
      logo: "jpmorgan.jfif",
    },
    {
      name: "American Express",
      logo: "american_express.png",
    },
    {
      name: "Meta",
      logo: "meta.png",
    },
    {
      name: "Citi",
      logo: "citi.png",
    },
    {
      name: "HSBC",
      logo: "hsbc.png",
    },
    {
      name: "McKinsey & Company",
      logo: "mckinsey.png",
    },
    {
      name: "Facebook",
      logo: "facebook.png",
    },
    {
      name: 'Morgan Stanley',
      logo: "morgan_stanley.png",
    },
    {
      name: "Boston Consulting Group (BCG)",
      logo: "bcg.png",
    },
    {
      name: "PwC",
      logo: "pwc.png",
    },
    {
      name: "Netflix",
      logo: "netflix.png",
    },
    {
      name: "Bain & Company",
      logo: "bain.png",
    },
    {
      name: "Directi",
      logo: "directi.jfif",
    },
    {
      name: "IQVIA",
      logo: "iqvia.png",
    },
    {
      name: "Kotak Mahindra Bank",
      logo: "kotak.png"
    },
    {
      name: "BNY Mellon",
      logo: "bny_mellon.png",
    },
    {
      name: "Hexagon Capability Center India Pvt. Ltd.",
      logo: "hexagon.png"
    }
  ]
    
    
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 6
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 2
        }
      };
    return (
        <ServicesContainer id='partner'>
        <ServicesH1>Companies</ServicesH1>
        
  <hr/>      
<Carousel responsive={responsive}  
swipeable={true}
  draggable={true}
  showDots={false}
  ssr={true} // means to render carousel on server-side.
  infinite={true}
  autoPlay={ true }
  focusOnSelect={true}
  className="car2 "
  sliderClass='slid'
  autoPlaySpeed={3000}
  centerMode={false}
  keyBoardControl={true}
  customTransition="transform 3000ms linear"
  transitionDuration={200}
  containerClass="carousel-container"
  dotListClass="custom-dot-list-style"
  itemClass="carousel-item-padding-40-px"
  renderDotsOutside={false}>
 
 {company.map((item) => {
    return (
      <img src={require('../../../images/company_logo/' + item.logo)} className="sponcer_bigimg1" alt={item.name}/>
    )
 })}
 {/* <img src="https://i.ibb.co/gtwSgFC/prs.png" className="sponcer_bigimg1" alt="Parterns_img"/>
<img src="https://i.ibb.co/R7H0cJd/CSTEP-Logo-Color.png"  className="sponcer_bigimg1"alt="Parterns_img"/>
<img src="https://i.ibb.co/QMbrXjh/School-Of-Politics.png" className="sponcer_bigimg1"  alt="Parterns_img"/>
<img src="https://i.ibb.co/k1CNFr6/Bala-Janagraha.png"  className="sponcer_bigimg1" alt="Parterns_img"/>
<img src="https://i.ibb.co/sgh2fFc/class-sathi.png" className="sponcer_bigimg1" alt="Parterns_img"/>
<img src="https://startupxplore.com/uploads/ff8080816ca837ec016ca9da915c00dc-large.png"  className="sponcer_bigimg1"alt="Parterns_img"/>
<img src="https://i1.wp.com/iasdelhi.org/wp-content/uploads/2018/06/forumIAS_logo.png" className="sponcer_bigimg1" alt="Parterns_img"/>
<img src="https://i.ibb.co/Ypx07jS/unnamed.jpg" alt="Parterns_img" className="sponcer_bigimg1"/>
<img src="https://i.ibb.co/vhgbx4t/Taghive.png" className="sponcer_bigimg1" alt="Parterns_img"/>
<img src="https://i.ibb.co/F75RcvW/Jarvis-Logo-2-X2-ft.png" className="sponcer_bigimg1"  alt="Parterns_img"/>
<img src="https://i.ibb.co/FBRyDsG/moolya.png" className="sponcer_bigimg1" alt="Parterns_img"/>
<img src="https://i.ibb.co/sWKHtXS/C3s-India-Default-Image.jpg" alt="Parterns_img" className="sponcer_bigimg1"/>
<img src="https://i.ibb.co/sQ6gqJf/wp-favicon3-1.png"  className="sponcer_bigimg1" alt="Parterns_img"/>

        */}
        
  
</Carousel>
<hr/>
</ServicesContainer>
 )
}

export default Slider